/* SearchHeading.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _ = "._1mou1fhj{margin-block:var(--ds-space-100) var(--ds-space-200)}";
import { H3 } from '@atlassian/mpac-primitives';
import React from 'react';
const H1 = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(H3, _extends({
    as: "h1"
  }, props), children);
};
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H1,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1mou1fhj", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const toCapitalCase = str => str.charAt(0).toUpperCase() + str.slice(1);
const SearchHeading = _ref3 => {
  let {
    isSearchQueryActive,
    areFiltersActive,
    productName
  } = _ref3;
  if (productName) {
    return /*#__PURE__*/React.createElement(Heading, null, isSearchQueryActive || areFiltersActive ? "Search results for ".concat(toCapitalCase(productName)) : "Explore apps for ".concat(toCapitalCase(productName)));
  }
  return /*#__PURE__*/React.createElement(Heading, null, isSearchQueryActive || areFiltersActive ? 'Search results' : 'Search for apps');
};
export default SearchHeading;